import { render, staticRenderFns } from "./materialHome.vue?vue&type=template&id=392aca4d&scoped=true&"
import script from "./materialHome.vue?vue&type=script&lang=js&"
export * from "./materialHome.vue?vue&type=script&lang=js&"
import style0 from "./materialHome.vue?vue&type=style&index=0&id=392aca4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392aca4d",
  null
  
)

export default component.exports